/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Promotion20Inputs */

const en__field_enum_csjensblank_promotion20 = /** @type {(inputs: _Field_Enum_Csjensblank_Promotion20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

const de__field_enum_csjensblank_promotion20 = /** @type {(inputs: _Field_Enum_Csjensblank_Promotion20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

/**
* | output |
* | --- |
* | "Promotion" |
*
* @param {_Field_Enum_Csjensblank_Promotion20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_promotion20 = /** @type {((inputs?: _Field_Enum_Csjensblank_Promotion20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Promotion20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_promotion20(inputs)
	return de__field_enum_csjensblank_promotion20(inputs)
});
export { _field_enum_csjensblank_promotion20 as "_field_enum_CSJENSBLANK_PROMOTION" }